import { Dashboard } from 'components/Dashboard.jsx';
import { Users } from 'models/UserCollection';
import { LadderLinker } from 'components/LadderLinker';
import { Request } from 'components/Request';
import { clearInlineError, showInlineError } from 'components/inlineFeedback';

import { User } from 'models/User';
import { ChatRoom } from 'models/ChatRoom.jsx';

import { Match } from 'models/Match.jsx';
import 'components/Jquery.autocomplete.jsx';
import { ChatMessageNotification } from '../models/ChatMessage';

import Globals from 'components/Globals';
import store from 'react/redux/store/store';
import { userlistIsVisibleForFocus, onUserlistVisibilityChange } from 'components/userlistVisibility';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';

export var ChatActions = {};

ChatActions.addNotificationToChat = function(chatContainer, notificationMessage, withOuterClasses = '') {
	if(chatContainer instanceof Match) {

	}
	if(Array.isArray(notificationMessage)) {
		var builtMessage = $('<span>');
		for(var i = 0; i < notificationMessage.length; i++) {
			builtMessage.append(notificationMessage[i]);
		}
		notificationMessage = builtMessage;
	}
	if(chatContainer === null) {
		chatContainer = ChatRoom.getActiveMainChat();
		if(!chatContainer) {
			return;
		}
	}
	if(chatContainer instanceof Match) {
		chatContainer.postNotification(notificationMessage);
	}
	else if(chatContainer instanceof ChatRoom) {
		chatContainer.chatMessages.addNotification(notificationMessage);
	}
	else {
		console.error('missing target, possibly retrieve active visible chat room?');
		console.log(chatContainer);
	}
};

ChatActions.getActiveChatContainer = function() {
	var mainChats;
	var button = ChatActions.activeChatButton;
	if(button) {
		mainChats = button.data('chat');
	}
	else {
		mainChats = $();
	}
	if(mainChats && mainChats.length) {
		return mainChats.data('chat');
	}
	else {
		return Dashboard.mainChatHolderTemplate.data('chat');
	}
};

ChatActions.chatFocus = function(chatId = null, socketOnly) {
	const chatState = store.getState().chat;
	const { selectedMainChat } = chatState;
	const userlistVisible = userlistIsVisibleForFocus(chatState);

	if(!socketOnly && chatId) {
		Request.apiv1('chat/focus', { chat_room_id: chatId });
	}
	if(!chatId) {
		chatId = selectedMainChat ? selectedMainChat.id : null;
	}
	if(!chatId) {
		return;
	}
	if(!Dashboard.serverConnection) {
		return;
	}
	Dashboard.serverConnection.send({
		id: chatId,
		userlistVisible: userlistVisible,
	}, 'chat_focus');
};

// The People column showing or hiding changes whether the socket should send userlist changes.
onUserlistVisibilityChange(() => ChatActions.chatFocus(null, true));

ChatActions.activeChatButton = null;


ChatActions.getChatMessages = function(chatRoomId) {
	return ChatRoom.getChatMessagesForActiveChat(chatRoomId);

};
ChatActions.joinChatRoomById = async function(id) {
	id = Number.parseInt(id, 10);
	if(!id) {
		throw new Error('Id not found');
	}
	const data = { id: id };
	const chat = ChatRoom.isInChatById(id);
	if(chat) {
		return chat.setActive();
	}
	return Request.apiv1('chat/join', data).then(applyJoinedRoom, Request.generalJsonError);
};

// The answer to chat/join and chat/create_room: the room, its messages and userlist.
function applyJoinedRoom(response) {
	Globals.initialChat = response.chat_id;
	Dashboard.performOpenSearchUpdate(response);
	return true;
}

// Public rooms whose name starts with query, or room #query: [{id, name, colors, members, online}].
ChatActions.searchRooms = function(query) {
	return Request.apiv1Get('chat/search_rooms', { query: String(query) })
		.then((response) => (response && response.rooms) || []);
};

// Always makes a new room, even when another room has the name, and joins it.
ChatActions.createChatRoom = function(name) {
	name = String(name || '').trim();
	if(!name) {
		return Promise.reject();
	}
	return Request.apiv1('chat/create_room', { name: name }).then(applyJoinedRoom, Request.generalJsonError);
};

ChatActions.highlightUsernameInChats = function(username) {
	if(!_.isString(username) && !(username instanceof User)) {
		return;
	}
	if(isNetplayPageActive() || username instanceof User) {

		const mainChat = ChatRoom.getActiveMainChat();
		if(mainChat) {
			mainChat.chatMessages.highlightPlayerByUsername(username);
		}
		return;
	}

	const currentChat = $(document);
	username = username.toLowerCase();
	if(!currentChat || !currentChat.length) {
		return;
	}
	currentChat.find('.chat_message.user_listed_' + username).addClass('hover_highlight');
};
ChatActions.inviteErrorMessageGenerator = function(invitee, inviteData, chatTarget) {
	const player = Users.update({
		id: inviteData.player_id,
		username: inviteData.username,
	});
	if(!chatTarget) {
		chatTarget = null;
	}
	let notification = null;
	var errorTypes = {
		player_no_exist: function() {
			return ChatMessageNotification.create({
				type: ChatMessageNotification.types.INVITE_PLAYER_NO_EXIST,
				player: player
			});
		},
		no_permission: function() {
			return ChatMessageNotification.create({
				type: ChatMessageNotification.types.INVITE_NO_PERMISSION,
				player: player
			});
		},
		already_invited: function() {
			return ChatMessageNotification.create({
				type: ChatMessageNotification.types.INVITE_ALREADY_INVITED,
				player: player
			});
		},
		in_there: function() {
			return ChatMessageNotification.create({
				type: ChatMessageNotification.types.INVITE_IN_THERE,
				player: player
			});
		}
	};
	if(errorTypes[inviteData.error_type]) {
		const notification = errorTypes[inviteData.error_type]();
		ChatActions.addNotificationToChat(chatTarget, notification);
	}
	else {
		ChatActions.addNotificationToChat(chatTarget, inviteData.error);
	}
};

ChatActions.removeUsernameHighlightInChat = function(username = true) {
	var currentChat;
	if(isNetplayPageActive()) {
		const mainChat = ChatRoom.getActiveMainChat();
		if(mainChat) {
			mainChat.chatMessages.removeUsernameHighlight();
		}
		return;
	}
	else {
		currentChat = $(document);
	}
	if(!currentChat || !currentChat.length) {
		return;
	}
	if(username === true) {
		currentChat.find('.chat_message').removeClass('hover_highlight');
	}
	else if(typeof username === 'string') {
		username = username.toLowerCase();
		currentChat.find('.chat_message.user_listed_' + username).removeClass('hover_highlight');
	}
};

$.fn.autolinkerDefault = function() {

	return $(this).each(function() {
		var input = $(this);
		var result = Autolinker.link(input.html(), LadderLinker.autolinkerOptions);
		input.html(result);
	});
};

ChatActions.loadFeaturedChats = function(chatGroups) {
	return Request.apiv1Get('chat/featured', {})
		.then(function(response) {
			if(response.featured_chats) {
				$.each(response.featured_chats, function(index, chatInfo) {
					let chat = ChatRoom.create(chatInfo);
					chat.addToFeaturedList();
				});
			}
			if(response.ladder_chats) {
				$.each(response.ladder_chats, function(index, chatInfo) {
					let chat = ChatRoom.create(chatInfo);
					chat.addToFeaturedList();
				});
			}

		});
};

ChatActions.reportToMods = function(title, description, extraData) {
	var href = siteUrl + '/bugs/submit';
	let data = {};
	data.json = true;
	data.type = 4;
	$.extend(data, extraData);
	if(title) {
		data.title = title;
	}


	let popup = Dashboard.ladderPopup(null, 'Report to Mods').showLoader();
	$.get(href, data, function(response) {
		let content = $($.trim(response.html));
		let heading = content.find('.report_heading');
		heading.remove();
		popup.changeTitleText(heading.text());
		popup.updateContent(content);
		var form = content.find('form');
		form.off('submit').on('submit', function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			var data = form.serializeArray();
			var submitButtons = form.find(':submit');
			submitButtons.prop('disabled', true);
			var success = function() {
				submitButtons.prop('disabled', false);
			};
			var fail = function(response) {
				submitButtons.prop('disabled', false);
				showInlineError(form[0], response.error || 'There was an error');
			};
			clearInlineError(form[0]);
			data.push({ name: 'json', value: '1' });
			$.post(form.attr('action'), data, function(response) {
				if(response.success) {
					popup.updateContent($(response.html));
					success();
				}
				else {
					fail(response);
				}
			});
		});
	});
};